import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["data-cy"];
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = {
  class: "flex"
};
const _hoisted_5 = {
  class: "text-gray-700"
};
const _hoisted_6 = {
  key: 0,
  width: "8",
  height: "8",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_7 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_8 = {
  class: "flex justify-center"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  key: 1,
  class: "w-11/12 flex justify-center"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  class: "flex justify-center"
};
const _hoisted_14 = {
  class: "w-full max-w-lg mx-auto p-6 bg-white"
};
const _hoisted_15 = {
  key: 0,
  class: "mb-8"
};
const _hoisted_16 = {
  class: "w-full text-sm"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  class: "py-1 text-gray-700"
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  class: "py-1 text-gray-700"
};
const _hoisted_21 = {
  key: 2,
  "data-cy": "emailPreviewReplenishmentRow"
};
const _hoisted_22 = {
  class: "py-1 text-gray-700"
};
const _hoisted_23 = {
  class: "border-t border-gray-300"
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  class: "w-full text-sm"
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  key: 1
};
const _hoisted_28 = {
  class: "flex justify-center"
};
const _hoisted_29 = {
  class: "p-4 pr-8 w-4/12"
};
const _hoisted_30 = {
  class: "pt-1 pb-2"
};
const _hoisted_31 = {
  class: "warning mb-2"
};
import { reactive } from 'vue';
import LlTextField from '@/components/LlTextField.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { isValidSingleEmail } from '../../services/utils';
export default {
  __name: 'EmailPreviewDialog',
  props: {
    dialog: {
      type: Boolean,
      required: false,
      default: false
    },
    state: {
      type: Object,
      required: true
    },
    modules: {
      type: Array,
      required: true
    },
    accountSummary: {
      type: Object,
      required: false
    },
    hasExpenseAttachments: {
      type: Boolean,
      required: true
    },
    hasTrustAttachment: {
      type: Boolean,
      required: true
    },
    invoiceList: {
      type: Array,
      required: false
    },
    testEmailState: {
      type: Object,
      required: true,
      default: {
        isTestEmail: false,
        testEmailAddress: ''
      }
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  emits: ['testEmail', 'openPreview'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const previewState = reactive({
      isEmailValid: false,
      emailErrorMessage: ''
    });
    const moduleList = [{
      id: 0,
      name: 'Invoice',
      enabled: true
    }, {
      id: 7,
      name: 'Trust Statement',
      enabled: isEnabled(7) && props.hasTrustAttachment
    }];
    function isEnabled(moduleId) {
      return props.modules?.find(module => module.id === moduleId)?.enabled;
    }
    function testEmail() {
      props.testEmailState.isTestEmail = true;
      emits('testEmail');
    }
    function validateEmail() {
      /**
       * Using centralized email validation from utils
       * For test email, we need to use single email validation since this will be used
       * as the test recipient address and cannot contain multiple emails
       */
      if (isValidSingleEmail(props.testEmailState.testEmailAddress)) {
        previewState.isEmailValid = true;
        previewState.emailErrorMessage = '';
      } else {
        previewState.isEmailValid = false;
        previewState.emailErrorMessage = 'Please enter a valid email address. The test email field can only contain a single email address.';
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "flex flex-row",
        "data-cy": __props.dialog ? 'email-preview-dialog' : 'email-preview-inline'
      }, [_createElementVNode("div", {
        class: _normalizeClass({
          'bg-white p-8 w-8/12': __props.dialog,
          'w-full': !__props.dialog
        }),
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.$emit('openPreview'), ["prevent"]))
      }, [_createElementVNode("div", {
        class: _normalizeClass(["bg-gray-100 rounded-md w-full p-6", {
          'text-small': !__props.dialog,
          'text-sm': __props.dialog
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass([{
          'padding-semi': !__props.dialog,
          'py-1': __props.dialog
        }, "font-semibold"])
      }, " Sender Info ", 2), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass([{
          'padding-small': !__props.dialog,
          'py-1': __props.dialog
        }, "text-gray-500"])
      }, " Sender Name ", 2), _createElementVNode("div", {
        class: _normalizeClass([{
          'padding-small': !__props.dialog,
          'py-1': __props.dialog
        }, "pl-2"])
      }, _toDisplayString(__props.state.fromName), 3)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass([{
          'padding-small': !__props.dialog,
          'py-1': __props.dialog
        }, "text-gray-500"])
      }, " Sender Email ", 2), _createElementVNode("div", {
        class: _normalizeClass([{
          'padding-small': !__props.dialog,
          'py-1': __props.dialog
        }, "pl-2"])
      }, _toDisplayString(__props.state.fromEmail), 3)]), _createElementVNode("div", {
        class: _normalizeClass(["font-semibold", {
          'padding-semi': !__props.dialog,
          'py-2': __props.dialog
        }])
      }, " Email Preview ", 2), _createElementVNode("div", {
        class: _normalizeClass(["bg-white", {
          'p-1': !__props.dialog,
          'p-4': __props.dialog
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass({
          'padding-small px-1': !__props.dialog,
          'p-2': __props.dialog
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(["text-gray-500", {
          'padding-small': !__props.dialog,
          'py-1': __props.dialog
        }])
      }, " Subject ", 2), _createElementVNode("div", {
        class: _normalizeClass({
          'padding-small': !__props.dialog,
          'py-1': __props.dialog
        })
      }, _toDisplayString(__props.state.subject), 3)], 2), _createElementVNode("div", {
        class: _normalizeClass(["flex", {
          'padding-small px-1 h-4': !__props.dialog,
          'p-2 h-10': __props.dialog
        }])
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(moduleList, module => {
        return _createElementVNode("div", {
          key: module.id
        }, [_withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [!__props.dialog ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[3] || (_cache[3] = [_createElementVNode("path", {
          d: "M7.45 17.5C5.93333 17.5 4.64583 16.9625 3.5875 15.8875C2.52917 14.8125 2 13.5167 2 12C2 10.4833 2.52083 9.1875 3.5625 8.1125C4.60417 7.0375 5.88333 6.5 7.4 6.5H18.15C19.2167 6.5 20.125 6.87917 20.875 7.6375C21.625 8.39583 22 9.30833 22 10.375C22 11.4417 21.625 12.3542 20.875 13.1125C20.125 13.8708 19.2167 14.25 18.15 14.25H8.275C7.64167 14.25 7.10417 14.0333 6.6625 13.6C6.22083 13.1667 6 12.6333 6 12C6 11.3667 6.22917 10.8333 6.6875 10.4C7.14583 9.96667 7.69167 9.75 8.325 9.75H18.15V10.75H8.3C7.95 10.75 7.64583 10.8708 7.3875 11.1125C7.12917 11.3542 7 11.65 7 12C7 12.35 7.125 12.6458 7.375 12.8875C7.625 13.1292 7.925 13.25 8.275 13.25H18.15C18.95 13.25 19.625 12.9708 20.175 12.4125C20.725 11.8542 21 11.175 21 10.375C21 9.575 20.725 8.89583 20.175 8.3375C19.625 7.77917 18.95 7.5 18.15 7.5H7.35C6.13333 7.5 5.10417 7.94167 4.2625 8.825C3.42083 9.70833 3 10.7667 3 12C3 13.25 3.42917 14.3125 4.2875 15.1875C5.14583 16.0625 6.19167 16.5 7.425 16.5H18.15V17.5H7.45Z",
          fill: "#747474"
        }, null, -1)]))])) : _createCommentVNode("", true), __props.dialog ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[4] || (_cache[4] = [_createElementVNode("path", {
          d: "M7.45 17.5C5.93333 17.5 4.64583 16.9625 3.5875 15.8875C2.52917 14.8125 2 13.5167 2 12C2 10.4833 2.52083 9.1875 3.5625 8.1125C4.60417 7.0375 5.88333 6.5 7.4 6.5H18.15C19.2167 6.5 20.125 6.87917 20.875 7.6375C21.625 8.39583 22 9.30833 22 10.375C22 11.4417 21.625 12.3542 20.875 13.1125C20.125 13.8708 19.2167 14.25 18.15 14.25H8.275C7.64167 14.25 7.10417 14.0333 6.6625 13.6C6.22083 13.1667 6 12.6333 6 12C6 11.3667 6.22917 10.8333 6.6875 10.4C7.14583 9.96667 7.69167 9.75 8.325 9.75H18.15V10.75H8.3C7.95 10.75 7.64583 10.8708 7.3875 11.1125C7.12917 11.3542 7 11.65 7 12C7 12.35 7.125 12.6458 7.375 12.8875C7.625 13.1292 7.925 13.25 8.275 13.25H18.15C18.95 13.25 19.625 12.9708 20.175 12.4125C20.725 11.8542 21 11.175 21 10.375C21 9.575 20.725 8.89583 20.175 8.3375C19.625 7.77917 18.95 7.5 18.15 7.5H7.35C6.13333 7.5 5.10417 7.94167 4.2625 8.825C3.42083 9.70833 3 10.7667 3 12C3 13.25 3.42917 14.3125 4.2875 15.1875C5.14583 16.0625 6.19167 16.5 7.425 16.5H18.15V17.5H7.45Z",
          fill: "#747474"
        }, null, -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", {
          class: _normalizeClass({
            'pl-0.5 pt-0.5': !__props.dialog,
            'pl-2': __props.dialog
          })
        }, _toDisplayString(module.name), 3)], 512), [[_vShow, module.enabled]])]);
      }), 64))], 2), _createElementVNode("div", null, [_createElementVNode("div", {
        class: _normalizeClass(["rounded border-gray-400 bg-white", {
          'padding-small px-1': !__props.dialog,
          'p-2': __props.dialog
        }])
      }, [_createElementVNode("div", _hoisted_8, [__props.state.logoUrl ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex justify-center w-11/12", {
          'h-30, w-30': !__props.dialog
        }])
      }, [_createElementVNode("img", {
        src: props.leanLawAuth.domain + '/v1/invoicedeliverysettings/logo'
      }, null, 8, _hoisted_9)], 2)) : (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[5] || (_cache[5] = [_createElementVNode("div", null, [_createElementVNode("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("path", {
        d: "M4.125 5.5V1.375H6.875V5.5H11V8.25H6.875V12.375H4.125V8.25H0V5.5H4.125ZM8.25 13.75V9.625H12.375V5.5H22L24.5163 8.25H28.875C30.3875 8.25 31.625 9.4875 31.625 11V27.5C31.625 29.0125 30.3875 30.25 28.875 30.25H6.875C5.3625 30.25 4.125 29.0125 4.125 27.5V13.75H8.25ZM17.875 26.125C21.67 26.125 24.75 23.045 24.75 19.25C24.75 15.455 21.67 12.375 17.875 12.375C14.08 12.375 11 15.455 11 19.25C11 23.045 14.08 26.125 17.875 26.125ZM13.475 19.25C13.475 21.6838 15.4412 23.65 17.875 23.65C20.3088 23.65 22.275 21.6838 22.275 19.25C22.275 16.8162 20.3088 14.85 17.875 14.85C15.4412 14.85 13.475 16.8162 13.475 19.25Z",
        fill: "#C4C4C4"
      })])], -1), _createElementVNode("div", {
        class: "px-2 py-3"
      }, "LOGO", -1)]))]))])], 2)]), _createElementVNode("div", {
        class: _normalizeClass({
          'padding-semi px-3': !__props.dialog,
          'py-2 px-8': __props.dialog
        })
      }, [__props.dialog ? (_openBlock(), _createElementBlock("pre", _hoisted_11, _toDisplayString(__props.state.body), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(__props.state.body), 1))], 2), _createElementVNode("div", {
        class: _normalizeClass(["border-gray-400 bg-white", {
          'padding-small px-1': !__props.dialog,
          'p-2': __props.dialog
        }])
      }, [_createElementVNode("div", _hoisted_13, [isEnabled(8) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["w-2/5 rounded-sm text-white text-center", {
          'padding-small p-0.5': !__props.dialog,
          'p-2': __props.dialog
        }]),
        style: _normalizeStyle({
          backgroundColor: __props.state.buttonColor || '#000000'
        })
      }, " Pay Invoice ", 6)) : _createCommentVNode("", true), isEnabled(1) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["ml-1 w-2/5 rounded-sm text-white text-center", {
          'padding-small p-0.5': !__props.dialog,
          'p-2': __props.dialog
        }]),
        style: _normalizeStyle({
          backgroundColor: __props.state.buttonColor || '#000000'
        })
      }, " Pay Balance ", 6)) : _createCommentVNode("", true)])], 2), _createElementVNode("div", _hoisted_14, [isEnabled(3) ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("h3", {
        class: _normalizeClass([!__props.dialog ? 'text-sm' : 'text-lg', 'font-bold', 'text-gray-900', 'mb-4'])
      }, " Account Summary ", 2), _createElementVNode("table", _hoisted_16, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[6] || (_cache[6] = _createElementVNode("td", {
        class: "py-1 text-gray-700"
      }, "Balance Forward", -1)), _createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-right', 'text-gray-900', 'font-medium']),
        "data-cy": "email-preview-balance-forward"
      }, _toDisplayString(_ctx.formatCurrency(__props.accountSummary.balanceForward)), 3)]), _createElementVNode("tr", null, [_cache[7] || (_cache[7] = _createElementVNode("td", {
        class: "py-1 text-gray-700"
      }, "New Charges", -1)), _createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-right', 'text-gray-900', 'font-medium']),
        "data-cy": "email-preview-new-charges"
      }, _toDisplayString(_ctx.formatCurrency(__props.accountSummary.invoiceAmount)), 3)]), __props.accountSummary.paymentReceived > 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [_createElementVNode("td", _hoisted_18, _toDisplayString(__props.accountSummary.appliedCreditMemos > 0 ? 'Payments and credits to this invoice' : 'Payments Received'), 1), _createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-right', 'text-red-600', 'font-medium']),
        "data-cy": "email-preview-payments-received"
      }, " -" + _toDisplayString(_ctx.formatCurrency(__props.accountSummary.paymentReceived)), 3)])) : _createCommentVNode("", true), __props.accountSummary.useTrust && (__props.accountSummary.paidFromTrust > 0 || __props.accountSummary.liveTrust) ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [_createElementVNode("td", _hoisted_20, " Paid from " + _toDisplayString(__props.accountSummary.trustTerm), 1), _createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-right', 'text-red-600', 'font-medium']),
        "data-cy": "email-preview-paid-from-trust"
      }, " -" + _toDisplayString(_ctx.formatCurrency(__props.accountSummary.paidFromTrust)), 3)])) : _createCommentVNode("", true), __props.accountSummary.useEvergreen && __props.accountSummary.liveTrust ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [_createElementVNode("td", _hoisted_22, _toDisplayString(__props.accountSummary.trustTerm) + " Replenishment Amount ", 1), _createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-right', 'text-gray-900', 'font-medium']),
        "data-cy": "email-preview-replenishment"
      }, _toDisplayString(_ctx.formatCurrency(__props.accountSummary.evergreenRecharge)), 3)])) : _createCommentVNode("", true), _createElementVNode("tr", _hoisted_23, [_createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-green-600', 'font-bold'])
      }, " To Pay ", 2), _createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-right', 'text-green-600', 'font-bold']),
        "data-cy": "email-preview-to-pay"
      }, _toDisplayString(_ctx.formatCurrency(__props.accountSummary.toPay)), 3)])])])])) : _createCommentVNode("", true), __props.accountSummary.hasFrozenTrustSummaryEnabled && __props.accountSummary.useTrust && (__props.accountSummary.liveTrust && !__props.accountSummary.useEvergreen || !__props.accountSummary.liveTrust) || __props.accountSummary.useEvergreen && __props.accountSummary.liveTrust ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("h4", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-md', 'font-semibold', 'text-gray-900', 'mb-4'])
      }, _toDisplayString(__props.accountSummary.trustTerm) + " Summary ", 3), _createElementVNode("table", _hoisted_25, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs italic' : 'text-sm italic', 'py-1', 'text-gray-700'])
      }, " Starting " + _toDisplayString(__props.accountSummary.trustTerm) + " Balance ", 3), _createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-right', 'text-gray-900', 'font-medium'])
      }, _toDisplayString(_ctx.formatCurrency(__props.accountSummary.beginningRetainerBalance)), 3)]), _createElementVNode("tr", null, [_createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs italic' : 'text-sm italic', 'py-1', 'text-gray-700'])
      }, " Ending " + _toDisplayString(__props.accountSummary.trustTerm) + " Balance ", 3), _createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-right', 'text-gray-900', 'font-medium'])
      }, _toDisplayString(_ctx.formatCurrency(__props.accountSummary.endingRetainerBalance)), 3)]), __props.accountSummary.useEvergreen && __props.accountSummary.liveTrust || __props.accountSummary.minimumRetainerBalance > 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [_createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs italic' : 'text-sm italic', 'py-1', 'text-gray-700'])
      }, _toDisplayString(__props.accountSummary.trustTerm) + " Minimum Balance ", 3), _createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-right', 'text-gray-900', 'font-medium'])
      }, _toDisplayString(_ctx.formatCurrency(__props.accountSummary.minimumRetainerBalance)), 3)])) : _createCommentVNode("", true), __props.accountSummary.useEvergreen && __props.accountSummary.liveTrust ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [_createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs italic' : 'text-sm italic', 'py-1', 'text-gray-700'])
      }, _toDisplayString(__props.accountSummary.trustTerm) + " Charge Amount ", 3), _createElementVNode("td", {
        class: _normalizeClass([!__props.dialog ? 'text-xs' : 'text-sm', 'py-1', 'text-right', 'text-gray-900', 'font-medium'])
      }, _toDisplayString(_ctx.formatCurrency(__props.accountSummary.evergreenRecharge)), 3)])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: _normalizeClass(["border-gray-400 bg-white", {
          'padding-small px-1': !__props.dialog,
          'p-2': __props.dialog
        }])
      }, [_createElementVNode("div", _hoisted_28, [isEnabled(9) && __props.hasExpenseAttachments ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["w-2/5 rounded-sm text-white text-center", {
          'padding-small p-0.5': !__props.dialog,
          'p-2': __props.dialog
        }]),
        style: _normalizeStyle({
          backgroundColor: __props.state.buttonColor || '#000000'
        })
      }, " Expenses ", 6)) : _createCommentVNode("", true)])], 2)], 2)], 2)], 2), _withDirectives(_createElementVNode("div", _hoisted_29, [_cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "text-base font-semibold pt-2 pb-1"
      }, "Send a test email", -1)), _withDirectives(_createElementVNode("div", _hoisted_30, " This will only be delivered to the email address you specify below and will not affect the email status. ", 512), [[_vShow, !__props.invoiceList?.length]]), _withDirectives(_createElementVNode("div", {
        class: "pt-1 pb-2"
      }, " This will only be delivered to the email address you specify below and will not affect the email status. We will only deliver the first invoice of the " + _toDisplayString(__props.invoiceList?.length) + " you have selected. ", 513), [[_vShow, __props.invoiceList?.length]]), _cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "py-2"
      }, "Send a test email to:", -1)), _createVNode(LlTextField, {
        id: "at-to-field",
        "data-cy": "testEmailTextField",
        modelValue: __props.testEmailState.testEmailAddress,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => __props.testEmailState.testEmailAddress = $event),
        type: "text",
        density: "compact",
        variant: "outlined",
        onBlur: validateEmail
      }, null, 8, ["modelValue"]), _createElementVNode("span", _hoisted_31, _toDisplayString(previewState.emailErrorMessage), 1), _createVNode(LlSecondaryButton, {
        id: "at-send-email",
        "data-cy": "testEmailSendButton",
        variant: "flat",
        color: "primary",
        class: "w-full",
        disabled: !previewState.isEmailValid,
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => testEmail(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Send ", -1)]))]),
        _: 1
      }, 8, ["disabled"])], 512), [[_vShow, __props.dialog]])], 8, _hoisted_1);
    };
  }
};